var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'production-mode': _vm.is_prod},attrs:{"id":"app"}},[(_vm.is_prod)?_c('div',{staticClass:"production-border"}):_vm._e(),_c('div',{staticClass:"flex"},[_c('TheNavigation'),_c('router-view',{staticClass:"app__content"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }